// import { updateMetaTags } from '../../utils/meta-tags-updater';
import { lazy, Suspense } from 'react';
import { Box, Container, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { API } from '../../interceptors/axios'
// import Categories from "../categories/Categories";
import Hero from "../hero/Hero";
import BackToTopButton from "../back-to-top-button/BackToTopButton"
import "./Home.css";
import "../../fonts/dameronbold.ttf";
import { fetchAuth } from '../../utils/auth';
import Spinner from "../spinner/Spinner";
import { useTheme } from '../../theme/theme-provider';
import ThemeAmbientOverlay from '../theme-ambient-overlay/ThemeAmbientOverlay';
// import { isSocialMediaPreview, getSocialPlatform } from '../../utils/social-media-detector';

const LazySongs = lazy(() => import('../songs/Songs'));
const LazyRightbar = lazy(() => import('../rightbar/Rightbar'));


const SpinnerWrapper = ({ children }) => (
  <Box
    sx={{
      position: 'relative',
      minHeight: '100px',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 2
    }}
  >
    {children}
  </Box>
);

const ImageCache = {
    store: new Map(),
    blobUrls: new Set(),
    
    async get(blogId) {
      try {
            // Try memory cache first
            if (this.store.has(blogId)) {
                const cached = this.store.get(blogId);
                // Verify blob URL is still valid
                const response = await fetch(cached);
                if (response.ok) return cached;
                
                // If URL is invalid, remove it
                this.store.delete(blogId);
                this.blobUrls.delete(cached);
                sessionStorage.removeItem(`image_${blogId}`);
            }
            
            // Try session storage (only non-blob URLs survive page reloads)
            const cacheKey = `image_${blogId}`;
            const cached = sessionStorage.getItem(cacheKey);
            if (cached && !cached.startsWith('blob:')) {
                try {
                    const response = await fetch(cached);
                    if (response.ok) {
                        this.store.set(blogId, cached);
                        return cached;
                    }
                    sessionStorage.removeItem(cacheKey);
                } catch {
                    sessionStorage.removeItem(cacheKey);
                }
            } else if (cached) {
                // Remove stale blob URL from sessionStorage
                sessionStorage.removeItem(cacheKey);
            }
            
            return null;
        } catch {
            return null;
        }
    },
    
    set(blogId, blob) {
       try {
        const url = URL.createObjectURL(blob);
        this.store.set(blogId, url);
        this.blobUrls.add(url);
        // Don't save blob URLs to sessionStorage — they're revoked on page reload
        return url;
      } catch (error) {
          console.error('Failed to cache image:', error);
          // Direct URL fallback for previews
          // This is a fallback for when the blob URL fails to create
          // ToDo: replace this with a separate image URL
          return `${process.env.REACT_APP_API_URL}/public-preview/${blogId}.jpg?v=${Date.now()}`;
        }
    },
    
    clear() {
        // Revoke all blob URLs
        this.blobUrls.forEach(url => {
            try {
                URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Failed to revoke URL:', error);
            }
        });
        this.blobUrls.clear();
        this.store.clear();
    }
};


const Home = ({sendPage}) => { 
  const { themeMode } = useTheme();
  // const defaultPreviewUrl = `${process.env.REACT_APP_API_URL}/default-preview.jpg?v=${Date.now()}`;

  // Pre-set meta tags for crawlers as early as possible
  // if (typeof window !== 'undefined' && isSocialMediaPreview()) {
  //   console.log("Pre-setting meta tags for crawler");
  //   updateMetaTags({
  //     title: 'Distorise Music Blog',
  //     description: 'Discover and enjoy unique music tracks on Distorise Music Blog',
  //     imageUrl: defaultPreviewUrl,
  //     type: 'website'
  //   });
  // }

  const [blogImageMap, setBlogImageMap] = useState({});
  const [blogData, setBlogData] = useState(null)
  const [loadingStates, setLoadingStates] = useState({
    popularBlogs: true,
    popularImages: false
  })


  const fetchBlogsData = async () => {    
      try {
          const blogs_popular_data = await API.get('/blogs-popular/');
          setBlogData(blogs_popular_data);

          // Build image URL map immediately — browser loads all in parallel natively
          const imageMap = {};
          blogs_popular_data.data.forEach(blog => {
              imageMap[blog.song] = `${process.env.REACT_APP_API_URL}/public-image/${blog.song}`;
          });
          setBlogImageMap(imageMap);

          setLoadingStates(prev => ({ ...prev, popularBlogs: false, popularImages: false }));
      } catch (error) {
          console.error("Error fetching data:", error);
          setLoadingStates(prev => ({ ...prev, popularBlogs: false, popularImages: false }));
      }
  };


  useEffect(() => {    
      const initializeData = async () => {
          try {
              
            // if (isSocialMediaPreview()) {
            //     const platform = getSocialPlatform();
            //     console.log(`Social media crawler detected on home page: ${platform || 'unknown'}`);
                
            //     updateMetaTags({
            //         title: 'Distorise Music Blog',
            //         description: 'Discover and enjoy unique music tracks on Distorise Music Blog',
            //         imageUrl: defaultPreviewUrl,
            //         pageUrl: window.location.href,
            //         type: 'website'
            //     });

            //     console.log("Social media preview tags updated for homepage with URL:", defaultPreviewUrl);
            //     return; // Skip full initialization for preview crawlers
            // }

            // Normal initialization for real users
            await fetchAuth(); // Ensure token is fresh on mount
            sendPage("home");
            await fetchBlogsData();

          } catch (error) {
              console.error('Initialization failed:', error);
          }
      };

      initializeData();

      return () => {
          ImageCache.clear();
      };
  }, []);


  return (
    <Box sx={{
      backgroundColor: 'var(--background-color)',
      minHeight: '100vh',
      pb: { xs: 4, sm: 6 } // Add bottom padding for mobile
      }}>      <Hero />
      <Box sx={{ position: 'relative', overflow: 'hidden' }}>
        <ThemeAmbientOverlay speed={30} />
        <Container sx={{ position: 'relative', zIndex: 1 }}>
        <hr style={{
         height: '12px',
         border: '0',
         width: '100%',
         boxShadow: 'inset 0 12px 12px -12px rgba(0, 0, 0, 0.5)'}}/>
        <Box flex={1}>
          <Typography
              id="Releases"
              className="Releases" 
              align='center' 
              variant='h3' 
              sx={{
                color: themeMode === 'dark' ? 'white' : 'rgba(22,22,22,0.94)',
                fontFamily: "Light-1",
                fontSize: { 
                  xs: '1.75rem',  // Small mobile devices (0-600px)
                  sm: '2.25rem',  // Tablets (600-900px)
                  md: '2.75rem',  // Small laptops (900-1200px)
                  lg: '3rem'      // Desktops (1200px+)
                }, // Responsive font size
                mb: { xs: 2, sm: 4 }
                }}>                  
            <b style={{
              color: themeMode === 'dark' ? 'white' : 'rgba(22,22,22,0.94)',
              textShadow: themeMode === 'dark' ? '4px 4px black' : '2px 2px rgba(255,255,255,0.65)'
              }}>Releases</b>
          </Typography>

          <BackToTopButton />

        </Box>        
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={{ xs: 3, sm: 4, md: 8 }}  // Increased spacing on mobile
            mt={{ xs: 2, sm: 4, md: 8 }}>
            {/* Songs Section */}
            <Box 
              flex={3} 
              sx={{ 
                padding: {
                  xs: "16px",
                  sm: "24px",
                  md: "18px 100px 100px 100px", },
                position: 'relative'
                }}>
              <Suspense fallback={
                <SpinnerWrapper>
                  <Spinner />
                  <Typography sx={{ 
                    color: themeMode === 'dark' ? 'white' : 'rgba(22,22,22,0.82)', 
                    mt: 2,
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                    }}>Loading releases...</Typography>
                </SpinnerWrapper>
              }>
                <LazySongs />
              </Suspense>
            </Box>

            {/* Rightbar Section */}
            <Box 
              flex={1} 
              sx={{ 
                position: 'relative',
                width: '100%',  // Full width on all screens
                maxWidth: { xs: '100%', sm: '450px', md: '100%' }, // Limit width on tablet
                mx: 'auto',  // Center on mobile and tablet
                mt: { xs: 2, md: 0 },
                overflow: 'hidden',  // Ensure content stays within borders
              }}>
              <Suspense fallback={
                <SpinnerWrapper>
                  <Spinner />
                  <Typography sx={{ 
                    color: themeMode === 'dark' ? 'white' : 'rgba(22,22,22,0.82)', 
                    mt: 2,
                    fontSize: { xs: '0.875rem', sm: '1rem' }
                    }}>Loading popular content...</Typography>
                </SpinnerWrapper>
              }>
                {loadingStates.popularImages ? (
                  <SpinnerWrapper>
                    <Typography sx={{ 
                      color: themeMode === 'dark' ? 'white' : 'rgba(22,22,22,0.82)', 
                      mb: 2,
                      fontSize: { xs: '0.875rem', sm: '1rem' }
                      }}>
                      Loading images... ({Object.keys(blogImageMap).length} of {blogData?.data?.length})
                    </Typography>
                    <Spinner />
                  </SpinnerWrapper>
                ) : (
                  blogData && <LazyRightbar 
                    blogs_popular={blogData.data} 
                    blogImageMap={blogImageMap} 
                    isLoading={false} 
                  />
                )}
              </Suspense>
            </Box>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default Home;